import { Button, IconButton, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useDynamicList, useUpdateEffect } from "ahooks";
import { IconTrash } from "@/components/Icon";
import { useTranslation } from "@/langs/useTranslation";
import ScheduleEventWrapper from "../../Calendar/ScheduleEventWrapper";
import ScheduleType from "./ScheduleType";
import ScheduleTaskType from "./TaskType";
import ScheduleTaskRange from "./TaskRange";
import TaskTime from "./TaskTime";

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #E9E8ED",
    marginTop: theme.spacing(2)
  },
  header: {
    backgroundColor: "#F8F9FC"
  },
  item: {
    display: "flex",
    alignItems: "center",

    "&:not(:last-child)": {
      borderBottom: "1px solid #E9E8ED"
    },
    "& > div": {
      padding: `10px ${theme.spacing(1.5)}px`,
      display: "flex",
      alignItems: "center",
      flex: 1
    },
    "& > div:first-child": {
      flex: 0.5
    },
    "& > div:nth-child(3)": {
      flex: 0.5
    },
    "& > div:last-child": {
      flex: 0.5
    }
  }
}));

const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.item, classes.header)}>
      <div>{t({ defaultMessage: "排程任务" })}</div>
      <div>{t({ defaultMessage: "循环模式" })}</div>
      <div>{t({ defaultMessage: "执行时间" })}</div>
      <div>{t({ defaultMessage: "执行期间" })}</div>
      <div></div>
    </div>
  );
};

const Item = ({ index, disabled, item, remove, onEditSuccess }) => {
  const classes = useStyles();
  const { t } = useTranslation("powerManagement");

  return (
    <div className={classes.item}>
      <Typography variant="body2" component="div">
        <ScheduleTaskType data={item} />
      </Typography>
      <Typography variant="body2" component="div">
        <ScheduleType data={item} />
      </Typography>
      <Typography variant="body2" component="div">
        <TaskTime data={item} />
      </Typography>
      <Typography variant="body2" component="span" style={{ flex: 1 }}>
        <ScheduleTaskRange data={item} />
      </Typography>
      <div>
        {!disabled && (
          <>
            <ScheduleEventWrapper
              editData={item}
              onEditSuccess={data => onEditSuccess(index, data)}
              onDeleteSuccess={() => {
                remove(index);
              }}
            >
              <Button color="primary" size="small">
                {t({ defaultMessage: "编辑" })}
              </Button>
            </ScheduleEventWrapper>
            <ScheduleEventWrapper
              isDelete
              editData={item}
              onDeleteSuccess={() => {
                remove(index);
              }}
            >
              <IconButton style={{ float: "right" }}>
                <IconTrash color="secondary" size={14} />
              </IconButton>
            </ScheduleEventWrapper>
          </>
        )}
      </div>
    </div>
  );
};

const TaskCreator = ({ disabled, name, value = [], onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { list, getKey, push, remove, replace } = useDynamicList(value);

  const handleAddSuccess = data => {
    push(data);
  };

  const handleEditSuccess = (index, data) => {
    replace(index, data);
  };

  useUpdateEffect(() => {
    onChange?.({ target: { name, value: list } });
  }, [list]);

  return (
    <>
      <ScheduleEventWrapper onAddSuccess={handleAddSuccess}>
        <Button color="primary" variant="contained" disabled={disabled}>
          {t({ defaultMessage: "添加排程任务" })}
        </Button>
      </ScheduleEventWrapper>
      <div className={classes.root}>
        <Header />
        {list.map((item, index) => (
          <Item
            key={getKey(index)}
            disabled={disabled}
            index={index}
            item={item}
            remove={remove}
            onEditSuccess={handleEditSuccess}
          />
        ))}
      </div>
    </>
  );
};

export default TaskCreator;
